<template>
  <div class="paternoster">
    <div class="left">
      <profile-paternoster-item image="paternoster-01.jpg" small="#" number="2" text="Energieversorger mit der größten Kunden&shy;zufriedenheit" />
      <profile-paternoster-item image="paternoster-02.jpg" number="100" text="Prozent Ökostrom für alle Tarife" />
      <profile-paternoster-item image="paternoster-03.jpg" small="Top" number="10" text="auf dem deutschen Onshore Windmarkt" />
      <profile-paternoster-item image="paternoster-04.jpg" small="Top" number="5" text="Contracting- Dienstleister in Deutschland" />
      <profile-paternoster-item image="paternoster-01.jpg" small="#" number="2" text="Energieversorger mit der größten Kunden&shy;zufriedenheit" />
      <profile-paternoster-item image="paternoster-02.jpg" number="100" text="Prozent Ökostrom für alle Tarife" />
      <profile-paternoster-item image="paternoster-03.jpg" small="Top" number="10" text="auf dem deutschen Onshore Windmarkt" />
      <profile-paternoster-item image="paternoster-04.jpg" small="Top" number="5" text="Contracting- Dienstleister in Deutschland" />
    </div>
    <div class="right">
      <profile-paternoster-item image="paternoster-05.jpg" :is-left="false" small="Top" number="10" text="Arbeitgeber unter den deutschen Energieversorgungs&shy;unternehmen" />
      <profile-paternoster-item image="paternoster-06.jpg" :is-left="false" size="smaller" number="1.000" text="installierte E-Lade&shy;punkte in Hannover und Region" />
      <profile-paternoster-item image="paternoster-07.jpg" :is-left="false" size="smaller" number="27.000" text="Wohneinheiten in Hannover mit Glas&shy;faser erschlossen" />
      <profile-paternoster-item image="paternoster-08.jpg" :is-left="false" number="560" text="Millionen Euro direkte Wertschöpfung in Hannover und Region." />
      <profile-paternoster-item image="paternoster-05.jpg" :is-left="false" small="Top" number="10" text="Arbeitgeber unter den deutschen Energieversorgungs&shy;unternehmen" />
      <profile-paternoster-item image="paternoster-06.jpg" :is-left="false" size="smaller" number="1.000" text="installierte E-Lade&shy;punkte in Hannover und Region" />
      <profile-paternoster-item image="paternoster-07.jpg" :is-left="false" size="smaller" number="27.000" text="Wohneinheiten in Hannover mit Glas&shy;faser erschlossen" />
      <profile-paternoster-item image="paternoster-08.jpg" :is-left="false" number="560" text="Millionen Euro direkte Wertschöpfung in Hannover und Region." />
    </div>
  </div>
</template>

<script>
  import ProfilePaternosterItem from "./ProfilePaternosterItem";
  export default {
    name: "ProfilePaternoster",
    components: {ProfilePaternosterItem}
  }
</script>

<style scoped>
  @media(min-width: 1000px) {
    .paternoster {
      position: relative;
      display: flex;
      align-items: flex-start;
      height: 100vh;
      overflow: hidden;
      margin: 0 0 0 350px;
    }
    .left, .right {
      position: relative;
      display: block;
      width: 290px;
      overflow: hidden;
    }
    .left {
      animation: move 26s linear infinite;
    }
    .right {
      animation: move 18s linear infinite;
    }
    @keyframes move {
      from {
        transform: translate3d(0, 0, 0);
      }
      to {
        transform: translate3d(0, -50%, 0);
      }
    }
  }
  @media(max-width: 999px) {
    .paternoster {
      position: relative;
      display: flex;
      align-items: flex-start;
      overflow: auto;
      margin: 0 -20px 20px;
      padding: 10px;
    }
    .left, .right {
      display: flex;
    }
    .right {
      padding-right: 30px;
    }
  }
  @media(max-width: 999px) and (min-width: 568px) {
    .paternoster {
      padding-left: calc(50vw - 285px);
      margin-bottom: calc(5vw + 20px);
    }
  }
</style>